// 2010-10-10 10:10:10
const formatTime = date => {
  date = new Date(date * 1000)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  // const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
}

const zipUrl = 'http://qcloudcdn.a311.ottcn.com/'

// 2010-10-10  2010/10/10
const formatDay = (date, f) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return [year, month, day].map(formatNumber).join(f)
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}
const cityList = [
  { value: '110000', label: '北京市' },
  { value: '120000', label: '天津市' },
  { value: '130000', label: '河北省' },
  { value: '140000', label: '山西省' },
  { value: '150000', label: '内蒙古自治区' },
  { value: '210000', label: '辽宁省' },
  { value: '220000', label: '吉林省' },
  { value: '230000', label: '黑龙江省' },
  { value: '310000', label: '上海市' },
  { value: '320000', label: '江苏省' },
  { value: '330000', label: '浙江省' },
  { value: '340000', label: '安徽省' },
  { value: '350000', label: '福建省' },
  { value: '360000', label: '江西省' },
  { value: '370000', label: '山东省' },
  { value: '410000', label: '河南省' },
  { value: '420000', label: '湖北省' },
  { value: '430000', label: '湖南省' },
  { value: '440000', label: '广东省' },
  { value: '450000', label: '广西壮族自治区' },
  { value: '460000', label: '海南省' },
  { value: '500000', label: '重庆市' },
  { value: '510000', label: '四川省' },
  { value: '520000', label: '贵州省' },
  { value: '530000', label: '云南省' },
  { value: '540000', label: '西藏自治区' },
  { value: '610000', label: '陕西省' },
  { value: '620000', label: '甘肃省' },
  { value: '630000', label: '青海省' },
  { value: '640000', label: '宁夏回族自治区' },
  { value: '650000', label: '新疆维吾尔自治区' },
  { value: '710000', label: '台湾省' },
  { value: '810000', label: '香港特别行政区' },
  { value: '820000', label: '澳门特别行政区' }
]
const androidVersions = [
  { label: '4', value: 14 },
  { label: '4.0', value: 14 },
  { label: '4.0.3', value: 15 },
  { label: '4.1', value: 16 },
  { label: '4.2', value: 17 },
  { label: '4.3', value: 18 },
  { label: '4.4', value: 19 },
  { label: '4.4W', value: 20 },
  { label: '5', value: 21 },
  { label: '5.0', value: 21 },
  { label: '5.1', value: 22 },
  { label: '6', value: 23 },
  { label: '6.0', value: 23 },
  { label: '6.0.1', value: 23 },
  { label: '7', value: 24 },
  { label: '7.0', value: 24 },
  { label: '7.1.1', value: 25 },
  { label: '8', value: 26 },
  { label: '8.0', value: 26 },
  { label: '8.1', value: 27 },
  { label: '9', value: 28 },
  { label: '9.0', value: 28 },
  { label: '10', value: 29 },
  { label: '10.0', value: 29 },
  { label: '11', value: 30 },
  { label: '11.0', value: 30 },
  { label: '12', value: 31 },
  { label: '12.0', value: 31 }
]

export default {
  formatTime,
  formatDay,
  zipUrl,
  cityList,
  androidVersions
}



// WEBPACK FOOTER //
// ./src/utils.js